import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AutomationProvider } from '@dain/automation-data'
import { AuthProvider } from './contexts/AuthContext'
import App from './App'
import './styles/globals.css'

// API base URL - empty string uses relative paths through Vite proxy
const API_BASE_URL = import.meta.env.VITE_API_URL || ''

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <AutomationProvider
        baseUrl={API_BASE_URL}
        onError={(error) => {
          console.error('API Error:', error)
        }}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AutomationProvider>
    </AuthProvider>
  </StrictMode>,
)
